import { PaymentInfoSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const ReceivePaymentRequestSchema = PaymentInfoSchema.extend({
  invoiceId: oz.string(),
}).openapi('ReceivePaymentRequest');

export type ReceivePaymentRequest = oz.infer<typeof ReceivePaymentRequestSchema>;
